import apiClient from './api';
import type { TelegramLinkStatus, TelegramLoginData } from '../types/telegram';

export const telegramService = {
  getLinkStatus: async (): Promise<TelegramLinkStatus> => {
    const response = await apiClient.get<TelegramLinkStatus>('/telegram/link');
    return response.data;
  },

  link: async (loginData: TelegramLoginData): Promise<TelegramLinkStatus> => {
    const response = await apiClient.post<TelegramLinkStatus>('/telegram/link', loginData);
    return response.data;
  },

  unlink: async (): Promise<void> => {
    await apiClient.delete('/telegram/link');
  },
};
